module.exports = __webpack_public_path__ + "img/logo.3063c23e.png";